import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { UserManagementService } from "../../core/services/user-management.service";
import { ValidateLogin } from "../../core/models/validate-login.dto";
import { UserRole } from "../../shared/enums/userRoles.enum";
import { OrdersListingComponent } from "./components/orders-listing/orders-listing.component";
import { OrderListingPaginatedComponent } from "./components/order-listing-paginated/order-listing-paginated.component";
import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-orders",
  templateUrl: "./orders.component.html",
  styleUrls: ["./orders.component.scss"],
  imports: [
    OrdersListingComponent,
    OrderListingPaginatedComponent,
    CommonModule,
  ],
})
export class OrdersComponent implements OnInit {
  userRole = 0;

  saleOrderListAdminStatus = false;
  saleOrderListNonAdminStatus = false;
  fromComponent = "";

  customerAccountNumber = "";

  @Input() isAdditionalFilters = false;
  @Input() orderType = "";
  @Input() isFromSupportAllocation = false;
  @Output() openOrderListingModal = new EventEmitter<boolean>();

  constructor(
    private _loginService: UserManagementService,
    private _router: Router
  ) {
    const state = this._router.getCurrentNavigation()?.extras.state;
    if (state) {
      this.customerAccountNumber = state["customerAccountNumber"];
    }
  }

  ngOnInit(): void {
    this.getUserRole();
  }

  getUserRole() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        if (this.userRole === UserRole.Admin) {
          this.saleOrderListAdminStatus = true;
        } else {
          this.saleOrderListNonAdminStatus = true;
        }
      });
  }

  closeModal() {
    this.openOrderListingModal.emit(false);
  }
}
